module.exports = __webpack_public_path__ + "img/checkmark-white.6ae57bcc.svg";